module.exports = __webpack_public_path__ + "static/media/3_1_taiwan1_thumd.48f11258.png";